import { Dispatch, SetStateAction } from "react";
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doFAVORITE_SET } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_WORKSPACE_FAVORITE_CREATE = "REQUEST_WORKSPACE_FAVORITE_CREATE";
export const doREQUEST_WORKSPACE_FAVORITE_CREATE = createDoRequestAction(
  REQUEST_WORKSPACE_FAVORITE_CREATE,
);

export const requestWorkspaceFavoriteCreateActionCreators = {
  doREQUEST_WORKSPACE_FAVORITE_CREATE,
};

interface Payload {
  type: string;
  payload: {
    requestId: string;
    projectId: string;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestWorkspaceFavoriteCreate({
  payload,
  setRequestResult,
}: Payload): SagaIterator {
  debug("saga*requestWorkspaceFavoriteCreate");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_FAVORITE_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/workspace-favorite-create`,
    accessToken,
    data: {
      projectId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_FAVORITE_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/workspace-favorite-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doFAVORITE_SET({
      ...result.payload,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_WORKSPACE_FAVORITE_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* workspaceFavoriteCreateSaga() {
  yield takeEvery(REQUEST_WORKSPACE_FAVORITE_CREATE, requestWorkspaceFavoriteCreate);
}
